export const UNBRANDED_CREDIT_CARD_TITLE = 'Creditcard';

export function paletteSeed(institutionName: string, bankName: string, accountId: string): string {
    return institutionName.trim() !== '' ? bankName : accountId;
}

interface CreditCardTitleInput {
    issuerName: string;
    hasIssuer: boolean;
    networkName: string;
    isNetworkKnown: boolean;
}

export function creditCardTitle({issuerName, hasIssuer, networkName, isNetworkKnown}: CreditCardTitleInput): string {
    if (hasIssuer) {
        return issuerName;
    }
    return isNetworkKnown ? networkName : UNBRANDED_CREDIT_CARD_TITLE;
}
